module.exports = __webpack_public_path__ + "img/guanyu_zhuanhuan@2x.a02ce6fa.png";